import {
  isToday,
  isYesterday,
  differenceInCalendarDays,
  format,
} from 'date-fns';

export type SessionGroupLabel = 'Today' | 'Yesterday' | 'Previous 7 Days' | 'Older';

/**
 * Returns the session grouping label for a given date string.
 * Groups: "Today", "Yesterday", "Previous 7 Days", "Older"
 */
export function getSessionGroupLabel(dateString: string): SessionGroupLabel {
  const date = new Date(dateString);

  if (isToday(date)) return 'Today';
  if (isYesterday(date)) return 'Yesterday';

  const daysDiff = differenceInCalendarDays(new Date(), date);
  if (daysDiff <= 7) return 'Previous 7 Days';

  return 'Older';
}

/**
 * Formats a date string into a human-readable timestamp.
 * Example: "Jan 15, 2025, 3:42 PM"
 */
export function formatTimestamp(dateString: string): string {
  const date = new Date(dateString);
  return format(date, 'MMM d, yyyy, h:mm a');
}

/**
 * The canonical ordering of session group labels for display.
 */
export const SESSION_GROUP_ORDER: SessionGroupLabel[] = [
  'Today',
  'Yesterday',
  'Previous 7 Days',
  'Older',
];
